<template>
  <div>
     <loading 
     class="green--text"
     :active.sync="loading" 
        :can-cancel="true"
        :is-full-page="true"
        ></loading>
    
    <v-divider></v-divider>
    <v-toolbar flat class="white ">
      <v-flex xs12 sm12 md12 >  
        <v-card flat color="white">
          <h3>Total Sales: <span class="green--text">{{locationNetworkInfo.sales|currency}} </span></h3>
          </v-card>
      </v-flex> 
    </v-toolbar>
    <v-card flat class="white py-1">
      <v-layout>
        <v-card-text>
          <v-container>
          <v-layout>
      <v-flex xs8 v-if="colData.length>0">
          <barchart
          v-if="loaded"
          :chartdata="stackedData"
          :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs4>
        <v-container justify-center>
           <v-flex >
      <doughnutchart
      v-if="loadedDonut"
      :chartdata="locationStatusSummary"
      :options="locationStatusSummaryOptions">
      </doughnutchart>
           </v-flex>
        </v-container>
      </v-flex>              
     </v-layout>
     </v-container>          
        </v-card-text>
      </v-layout>
 <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="networkInformation=true;totalCommissionInfo=false"
            class="grey--text"
            flat
            round
            color="grey"
          >By Network</v-tab>
          <v-tab
            @click="networkInformation=false;totalCommissionInfo=true"
            class="grey--text"
            flat
            round
            color="grey"
          >By Month</v-tab>
        </v-tabs>
      </v-toolbar>
        <v-card flat v-show="networkInformation">
      <v-data-table
        :headers="locationNetworkHeaders"
        :loading="isLoading"
        :items="locationNetworkInfo.locationArray"
        item-key="id"
        disable-initial-sort
        align-center
        style="cursor: pointer"
        :rows-per-page-items="[25, 50, 100, 250]"
      >
        <template v-slot:items="props">
          <td
            @click="routerLinkToDetails(props.item)"
            class="text-xs-center"
          >{{props.item.network.locationNode.name}}</td>
          <td @click="routerLinkToDetails(props.item)" 
          class="text-xs-center">{{props.item.network.name}}</td>
          <td
            @click="routerLinkToDetails(props.item)"
            class="text-xs-center"
          >{{props.item.location.count}}</td> 
          <td
            @click="routerLinkToDetails(props.item)"
            class="text-xs-center"
          >{{props.item.serviceAccounts.count}}</td>
          <td
            @click="routerLinkToDetails(props.item)"
            class="text-xs-center green--text"
          >{{(props.item.transaction)|currency}}</td> 
        </template>
      </v-data-table>
        </v-card>

         <v-card flat v-show="totalCommissionInfo">
      <v-data-table
        :headers="commissionHeaders"
        :items="totalCommissionList"
        item-key="id"
        disable-initial-sort
        align-center
        style="cursor: pointer"
        :rows-per-page-items="[25, 50, 100, 250]"
      >
        <template v-slot:items="props">
            <td
            class="text-xs-center"
          ><v-btn icon @click="exportCustomerSummaryTransactions(props.item.month, props.item.batchNumber, props.item.organisationId)"><v-icon>download</v-icon></v-btn></td>
          <td
            class="text-xs-center"
          >{{props.item.month}}</td>
          <td
            class="text-xs-center green--text"
          >{{(props.item.commission)|currency}}</td> 
        </template>
      </v-data-table>
        </v-card>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Api from "@/services/Api";
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import DoughnutChart from "./DoughnutChart.vue";
import dateformat from "dateformat";
import Transactions from "@/components/Transactions.vue";
import FinancialOverview from "@/components/FinancialOverview.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
var randomColor = require('randomcolor');
export default {
  components: {
    barchart: BarChart,
    piechart: PieChart,
    linechart: LineChart,
    doughnutchart: DoughnutChart,
    financialoverview: FinancialOverview,
    loading: Loading
  },
  data() {
    return {
      colMonths:[],
      totalCommissionList:[],
      totalCommissionInfo:false,
      networkInformation:true,
      packageData:[],
      monthArray:[],
      colData:[],
      newArray:[],
      stackedData: {},
      stackedDataOptions: {},
      customer: "",
      loading: true,
      loaded: false,
      loadedDonut:false,
      locationNetworks: [],
      locationNetworksLocations: [],
      Partners: [{ id: 1, name: "Fibre Geeks" }],
      locations: [],
      moneySummary:null,
      moneySummaryOptions:null,
      locationStatusSummary: null,
      allLocationTotals:[],
      locationSummary:[],
      passiveInstallsComplete:[],
      isLoading:true,
      activeInstallsComplete:[],
      moneySummaryDataLabels:['Sales','Cost of Sales','Expenses'],
      totals: [],
      allTotals: [],
      allLocations:[],
      salesValue: "",
      cosValue: "",
      expenseValue: "",
      loanValue: "",
      totalSalesValue: "",
      totalCosValue: "",
      totalExpenseValue: "",
      totalLoanValue: "",
      activeAccounts: [],
      activeAccountsCount:[],
      loanAccounts: [],
      lenders: [],
      loanAmounts: [],
      allTransactions: [],
      transactions:[],
      locationNetworkInfo: [],
      locationNetworkIds:[],
      buildCost: 0,
      locationNetworkHeaders: [
        {
          text: "Node",
          align: "center",
          value: "packageCat"
        },
        {
          text: "Network Name",
          align: "center",
          value: "packageCode"
        },
        {
          text: "Number of Units",
          align: "center",
          value: "basePackagePrice"
        },
        {
          text: "Live Units",
          align: "center",
          value: "basePackagePrice"
        },
        {
          text: "Commission",
          align: "center",
          value: "basePackagePrice"
        }
      
      ],
       commissionHeaders: [
         {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action"
        },
        {
          text: "Month",
          align: "center",
          value: "month"
        },
        {
          text: "Commission",
          align: "center",
          value: "commission"
        }
      
      ]
    };
  },
  async created() {
    await this.getTransactionForYear();
    this.getFibreFarmerDetails();
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user"]),
    
  },
  methods: {
    exportCustomerSummaryTransactions(period, batchNumber, organisationId) {
            Api()
                .get("/customer/transactions/export/" + organisationId + '/' + batchNumber).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href = 'data:application/vnd.ms-excel;base64,' + encodeURI(response.data);
                    hiddenElement.target = '_blank';
                    hiddenElement.download = period + '_sales_transactions.xls';
                    hiddenElement.click();
                })
        },
    generateBlueColours(count){
     return randomColor({
          count: count,
          hue: 'blue'
        });
    },   
      getRandomColors(number) {
  var letters = '0123456789ABCDEF';
  var color = '#';
  let array = {background: [], border: []}
  for (let x=0; x<number; x++){
      for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  array.border.push(color)
  array.background.push(this.pSBC(0.35, color))
  color = '#'
  }
  return array;
},
pSBC(p,c0,c1,l){
    let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
    if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
    if(!this.pSBCr)this.pSBCr=(d)=>{
        let n=d.length,x={};
        if(n>9){
            [r,g,b,a]=d=d.split(","),n=d.length;
            if(n<3||n>4)return null;
            x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
        }else{
            if(n==8||n==6||n<4)return null;
            if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
            d=i(d.slice(1),16);
            if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
            else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
        }return x};
    h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
    if(!f||!t)return null;
    if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
    else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
    a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
    if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
    else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)

  },
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
},
 
      async getTransactionForYear() {
      await Api()
        .get("/transactions/byCustomer/asSupplier/networkFullYear/"+ this.$store.state.currentOrg.org.id)
        .then(async response => {      
          this.transactions=response.data      
           
           var helper = {}
            this.monthArray = []
            let months = response.data.reduce((r, o) =>{
            let dateO = new Date(o.date)
            let month = dateO.getMonth()+1
            if(month<10){
            var key = dateO.getFullYear() + '-0' + month
            }else{
            var key = dateO.getFullYear() + '-' + month
            }
            if(!this.monthArray.includes(key)){
              this.monthArray.push(key)
            }
            if (!helper[key]) {
              helper[key] = Object.assign({}, o)
              r.push(helper[key])
            } else {
              r.push(helper[key])
            }

            return r
          }, [])
          let networks = [
            ...new Set(
              response.data.map(
                item => item.locationNetworkId
              )
            )
          ];

          this.packageData = [];
          await networks.map(x => {
            let find = response.data.find(
              z => z.locationNetworkId === x
            );
            this.packageData.push({
              id: x,
              locationNetwork: find.locationNetwork,
              count: response.data.filter(
                y => y.locationNetworkId === x
              ).length
            });
          });
          this.packageData.sort((a, b) =>
            a.count < b.count
              ? 1
              : b.count < a.count
              ? -1
              : 0
          );

           this.colData = []
          await this.monthArray.map(x => {
            let find = response.data.find(
              z => z.date.substring(0,7) === x
            );
            this.colData.push({
              id: x,
              month: find.date.substring(0,7),
              count: response.data.filter(
                y => y.date.substring(0,7) === x
              ).length
            });
            this.totalCommissionList.push({
              id: x,
              month: find.date.substring(0,7),
              batchNumber: find.batchNumber,
              organisationId: find.organisationId,
              count: (response.data.filter(
                y => y.date.substring(0,7) === x
              )),
              commission:0
            })
          });
          // this.colData.sort((a, b) =>
          //   a.count < b.count
          //     ? 1
          //     : b.count < a.count
          //     ? -1
          //     : 0
          // );
          // this.totalCommissionList.sort((a, b) =>
          //   a.count.length < b.count.length
          //     ? 1
          //     : b.count.length < a.count.length
          //     ? -1
          //     : 0
          // );
         this.newArray = []

          for (let a=0; a<this.packageData.length;a++){
              let color = await this.getRandomColors(1)
              let obj = {
                  locationNetworkId: this.packageData[a].locationNetwork.id,
                  label: this.packageData[a].locationNetwork.name,
                  backgroundColor: color.background,
                  borderColor: color.border,
                  borderWidth: 1,
                  data: []
              }
              this.newArray.push(obj)
                
          }
          for (let b=0; b<this.colData.length;b++){
              for (let c=0; c<this.newArray.length;c++){
                  let count = await response.data.filter(d=>
                  d.date.substring(0,7)===this.colData[b].month&&
                  d.locationNetworkId===this.newArray[c].locationNetworkId)
                  let amounts =0
                  for(let i=0; i<count.length; i++){
                    amounts+=count[i].amount
                  }

                  await this.newArray[c].data.push(amounts)

              }
          }
      let colors = this.generateBlueColours(this.packageData.length)
      console.log(colors)
       await this.newArray.map(z=>{
          let index = this.newArray.indexOf(z)
          z.backgroundColor = this.pSBC(0.35, colors[index])
          z.borderColor = colors[index]
        })
        this.colMonths = []
        for(let q=0; q<this.totalCommissionList.length; q++){
          this.colMonths.push(this.totalCommissionList[q].month)
          for(let w=0; w<this.totalCommissionList[q].count.length; w++){
            this.totalCommissionList[q].commission=this.totalCommissionList[q].commission+this.totalCommissionList[q].count[w].amount
          }
        }
          this.loadBarChart()
        })
        
    },
    async loadBarChart() {       
       let networkColors = this.getRandomColors()
        this.stackedData = {
        labels: this.colMonths,
        datasets: this.newArray
        },
      this.stackedDataOptions= {
      responsive: true, 
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          stacked: true,
          categoryPercentage: 0.8,
          barPercentage: 1
        }],
        yAxes: [{
          stacked: true
        }]
      },
      	tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function(tooltipItems, data) {
							return 'R' + tooltipItems.yLabel.toFixed(2);
						}
					}
        },
        }
      this.loaded = true
    },
    async loadChartData() {
      try {
          (this.locationStatusSummary = {
          labels: ["Units Passed", "Only Passive Install Complete","Active Install Complete"],
          datasets: [
            {
              label: "Unit Status Overview",
              data: this.locationNetworkInfo.locationSummary,
              backgroundColor: [
                'rgba(38,231,147, 0.2)',
                "rgba(255, 99, 132, 0.2)",
                'rgba(153, 102, 255, 0.2)'
              ],
              borderColor: ['rgba(38,231,147, 1)', "rgba(255, 99, 132, 1)",'rgba(153, 102, 255, 1)'],
              borderWidth: 1
            }
          ]
        }),
        (this.locationStatusSummaryOptions = {
          title: {
              display: true,
              text: "Unit Overview"
            }
          }),
         
          ((this.loadedDonut = true));
      } catch {}
    },
    routerLinkToDetails(item) {
      this.$router.push({ path: "/reseller/network/" + item.network.id });
    },
    async getFibreFarmerDetails() {
          await Api()
            .get(
              "/customer/reseller/fibreFarmerLocationNetwork"
            )
            .then(async response => {
                this.locationNetworkInfo=response.data
                this.loadChartData();
                this.isLoading = false;
                this.loading = false
            });
    },
    logout() {
      this.drawer = false;
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setPermission", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.state.isUserLoggedIn = false;
      this.$router.push("/login");
    },
  }
};
</script>
